import {
  IContract,
  IPaginationParams,
  IPaginationResponse,
  IPayout,
  ICashFlowData,
  ICalculationParametersData
} from 'types';
import { promiseActionFactory } from '@teroneko/redux-saga-promise';

export const loadContractsAction = promiseActionFactory<IPaginationResponse<IContract>>().create<IPaginationParams>('contracts/load');
export const loadContractPayoutsAction = promiseActionFactory<IPayout[]>().create<number>('contracts/loadPayouts');

export const loadCashFlowsAction = promiseActionFactory<ICashFlowData>().create<number>('contracts/loadCashFlows');
export const loadCalculationParametersAction = promiseActionFactory<ICalculationParametersData>().create<number>('contracts/loadCalculationParameters');
export const loadDownloadExcelAction = promiseActionFactory<Blob>().create<number>('contracts/downloadContractOplataExcel');

